"use strict";

exports.__esModule = true;
exports.createParser = createParser;

var _responsive = require("./responsive");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sort(obj) {
  const next = {};
  Object.keys(obj).sort((a, b) => a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base'
  })).forEach(key => {
    next[key] = obj[key];
  });
  return next;
}

function createParser(config) {
  const cache = new Map();

  const parser = props => {
    let styles = {};
    let shouldSort = false;
    const isCacheDisabled = props?.theme && props.theme.disableStyledSystemCache;

    for (const prop in props) {
      if (!config[prop]) continue;
      const systemConfig = config[prop];
      const scale = (0, _lodash.default)(props.theme, systemConfig.scale, systemConfig.defaultScale);
      let propValue = props[prop];
      if (propValue === undefined) return {};

      if (typeof propValue === 'function') {
        propValue = propValue(props.theme);
      }

      if (typeof propValue === 'object') {
        const breakpoints = !isCacheDisabled && cache.get('breakpoints') || (0, _lodash.default)(props.theme, 'breakpoints', _responsive.defaultBreakpoints);
        cache.set('breakpoints', breakpoints);

        if (Array.isArray(propValue)) {
          const mediaQueries = !isCacheDisabled && cache.get('mediaQueries') || [null, ...(0, _responsive.parseBreakpoints)(breakpoints)];
          cache.set('mediaQueries', mediaQueries);
          const responsiveStyles = (0, _responsive.parseResponsiveStyle)({
            cache,
            props,
            propValue,
            scale,
            systemConfig
          });
          styles = (0, _lodash2.default)(styles, responsiveStyles);
          continue;
        }

        if (propValue !== null) {
          shouldSort = true;
          const responsiveStyles = (0, _responsive.parseResponsiveObject)({
            cache,
            props,
            propValue,
            scale,
            systemConfig
          });
          styles = (0, _lodash2.default)(styles, responsiveStyles);
          continue;
        }
      }

      styles = { ...styles,
        ...systemConfig(propValue, scale, props)
      };
    }

    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parser.config = config;
  parser.propNames = Object.keys(config);
  parser.cache = cache;
  const keys = Object.keys(config).filter(k => !['config', 'propNames', 'cache'].includes(k));

  if (keys.length > 1) {
    keys.forEach(key => {
      Object.assign(parser, {
        [key]: createParser({
          [key]: config[key]
        })
      });
    });
  }

  return parser;
}